/**
 * Deployment-time client/brand identity. Single source of truth in the
 * frontend bundle — read from Vite's `import.meta.env.VITE_CLIENT_NAME`.
 *
 * Default 'CRM' keeps the code generic when no branding is configured.
 * To override, set `VITE_CLIENT_NAME=<value>` in `apps/web/.env`
 * (or in the build environment for CI / deploy). Backend has its own
 * `CLIENT_NAME` env var (see apps/api/src/config/env.ts) — keep them
 * in sync at deploy time.
 */
export const CLIENT_NAME: string = import.meta.env.VITE_CLIENT_NAME ?? 'CRM';
